import { useEffect } from "react";
import { BrowserView, isBrowser, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import SavingCreateMobile from "./savingCreateMobile";
import SavingCreateWeb from "./savingCreateWeb";
const SavingComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("Saving");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toCreatePage = (studentId: string) => {
    navigate(`/saving/create/${studentId}`);
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Saving",
    });
    if (isBrowser) {
    }
  }, []);
  return (
    <>
      <BrowserView>
        <SavingCreateWeb toCreatePage={toCreatePage}></SavingCreateWeb>
      </BrowserView>
      <MobileView>
        <SavingCreateMobile></SavingCreateMobile>
      </MobileView>
    </>
  );
};

export default SavingComponent;
